import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '100%',
    margin: '0 auto',
    padding: theme.spacing(3, 3, 6, 3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5),
    },
  },
  formContainer: {
    marginTop: theme.spacing(3),
  },
  item: {
    paddingTop: theme.spacing(1),
  },
  form: {
    marginTop: theme.spacing(3),
  },
}))
